import './config'
import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';          // ElementUI 基础样式
import 'element-ui/lib/theme-chalk/display.css';        // ElementUI 响应式隐藏样式
import hasPermission from './utils/hasPermission'

import print from 'vue-print-nb';//引入下载的print
import BigDecimal from 'js-big-decimal'

import '@fortawesome/fontawesome-free/css/all.min.css'; // 免费图标字体
import '@/permission';                                   // permission control
import { Graph } from '@antv/x6';

import router from './router'
import store from './store'
import  VueQuillEditor from 'vue-quill-editor'//调用编辑器

// 样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
// 全局使用
Vue.use(print);
Vue.use(VueQuillEditor)
Vue.use(hasPermission)
Vue.prototype.BigDecimal = BigDecimal
// Vue.component('vue-draggable-resizable', VueDraggableResizable);

// 注册返回 HTML 元素的函数
Graph.registerHTMLComponent('myhtml', (item) => {
   /* console.log("=====Graph.registerHTMLComponent=======")
    console.log(item.data);
    console.log("=====Graph.registerHTMLComponent=======")*/
    let node = document.createElement('div');
    node.innerHTML = `
            <div style="background-color:#f6f7fA;border-radius:8px">
                <img src=${item.data.img} alt="">
                <div class="text" style="text-align:center;width: 100%;margin-top:-5px">${item.data.label}</div>
            </div>`;
    return node;
});

new Vue({
    router,
    store,
    data: function () {
        return {
            menuUrl: [],
            leftActive: ['/home', '首页']
        }
    },
    render: h => h(App)
}).$mount('#app')
